import { API_URL } from '../config/apiConfig';

/**
 * Returns API endpoints and login route for a given role.
 * role: 'user' | 'admin' | 'vendor' | 'driver'
 */
export const getPasswordEndpoints = (role = 'user') => {
  const cleanRole = String(role || 'user').toLowerCase();

  switch (cleanRole) {
    case 'admin':
      return {
        // direct change-password (requires current password)
        changePasswordUrl: `${API_URL}/admin/auth/forgot-password`,
        // OTP flow: backend exposes POST /api/admin/auth/forgot-password (send OTP) and POST /api/admin/auth/reset-password (reset using OTP)
        sendOtpUrl: `${API_URL}/admin/auth/forgot-password`,
        verifyOtpUrl: `${API_URL}/admin/auth/reset-password`,
        resetUrl: `${API_URL}/admin/auth/reset-password`,
        loginUrl: '/admin/login',
      };

    case 'vendor':
      return {
        changePasswordUrl: `${API_URL}/vendor/forgot-password`,
        sendOtpUrl: `${API_URL}/vendor/forgot-password/send-otp`,
        verifyOtpUrl: `${API_URL}/vendor/forgot-password/verify-otp`,
        resetUrl: `${API_URL}/vendor/forgot-password/reset`,
        loginUrl: '/vendor/login',
      };

    case 'driver':
      return {
        changePasswordUrl: `${API_URL}/driver/auth/forgot-password`,
        sendOtpUrl: `${API_URL}/driver/auth/forgot-password/send-otp`,
        verifyOtpUrl: `${API_URL}/driver/auth/forgot-password/verify-otp`,
        resetUrl: `${API_URL}/driver/auth/reset-password`,
        loginUrl: '/driver/login',
      };

    default:
      return {
        changePasswordUrl: `${API_URL}/auth/forgotpassword`,
        sendOtpUrl: `${API_URL}/auth/forgotpassword/send-otp`,
        verifyOtpUrl: `${API_URL}/auth/forgotpassword/verify-otp`,
        resetUrl: `${API_URL}/auth/resetpassword`,
        loginUrl: '/login',
      };
  }
};
